export enum DataRequestState {
	None,
	Requested,
	Available,
	Forbidden,
	Failed,
}
